import React from "react";
import cn from "classnames";
import styles from "./Options.module.sass";
import Actions from "../../../components/Actions";

const Options = ({className, item, users}) => {
    return (
        <div className={cn(styles.options, className)}>
            <Actions className={styles.actions} item={item} users={users}/>
        </div>
    );
};

export default Options;
